import {
	CLEAR_NOTES,
	CLEAR_NOTE_CREATE_ERRORS,
	CLEAR_NOTE_UPDATE_ERRORS,
	CREATE_NOTE,
	CREATE_NOTE_FAILED,
	CREATE_NOTE_SUCCEEDED,
	DELETE_NOTE,
	DELETE_NOTE_FAILED,
	DELETE_NOTE_SUCCEEDED,
	FETCH_NOTES_FAILED,
	FETCH_NOTES_SUCCEEDED,
	GET_NOTES,
	UPDATE_NOTE,
	UPDATE_NOTE_FAILED,
	UPDATE_NOTE_SUCCEEDED,
} from './notes.action';
import { notesInitialState } from './notes.initialState';
import { clone, dissoc, path, pathOr } from 'ramda';

const createPendingState = (state, pendingType) => ({
	...state,
	[pendingType]: true,
});

const createErrorState = (state, pendingType, errorType, error) => ({
	...state,
	[pendingType]: false,
	[errorType]: error,
});

const clearErrorState = (state, errorType) => ({
	...state,
	[errorType]: null,
});

export const noteReducer = (state = notesInitialState, action) => {
	switch (action.type) {
		case CLEAR_NOTES: {
			return {
				...state,
				entities: notesInitialState.entities,
				isDirty: false,
				totalToDisplay: 0,
				skip: 0,
			};
		}

		case CLEAR_NOTE_UPDATE_ERRORS: {
			return clearErrorState(state, 'updateError');
		}

		case CLEAR_NOTE_CREATE_ERRORS: {
			return clearErrorState(state, 'createError');
		}

		case GET_NOTES: {
			return createPendingState(state, 'pendingFetch');
		}

		case UPDATE_NOTE: {
			return createPendingState(state, 'pendingUpdate');
		}

		case CREATE_NOTE: {
			return createPendingState(state, 'pendingCreate');
		}

		case DELETE_NOTE: {
			return createPendingState(state, 'pendingDelete');
		}

		case FETCH_NOTES_FAILED: {
			return createErrorState(state, 'pendingFetch', 'fetchError', action.payload);
		}

		case UPDATE_NOTE_FAILED: {
			return createErrorState(state, 'pendingUpdate', 'updateError', action.payload);
		}

		case CREATE_NOTE_FAILED: {
			return createErrorState(state, 'pendingCreate', 'createError', action.payload);
		}

		case DELETE_NOTE_FAILED: {
			return createErrorState(state, 'pendingDelete', 'deleteError', action.payload);
		}

		case FETCH_NOTES_SUCCEEDED: {
			const previousStateEntities = clone(state.entities);
			const data = pathOr([], ['payload', 'data'], action);
			const entities = data.reduce((accumulator, datum) => {
				accumulator[datum._id] = datum;

				return accumulator;
			}, previousStateEntities);

			const newTotal = path(['payload', 'total'], action);
			const newSkip =
				newTotal >= state.skip ? { skip: action.payload && action.payload.skip + 10 } : {};

			return {
				...state,
				entities,
				pendingFetch: false,
				isDirty: false,
				totalToDisplay: newTotal,
				...newSkip,
			};
		}

		case UPDATE_NOTE_SUCCEEDED: {
			const updatedNoteId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingUpdate: false,
			};

			if (updatedNoteId) {
				newState.entities = {
					...state.entities,
					[updatedNoteId]: action.payload,
				};
			}

			return newState;
		}

		case DELETE_NOTE_SUCCEEDED: {
			const deletedNoteId = path(['payload', '_id'], action);
			const newState = {
				...state,
				isDirty: true,
				pendingDelete: false,
			};

			if (deletedNoteId) {
				newState.entities = dissoc(deletedNoteId, state.entities);
			}

			return newState;
		}

		case CREATE_NOTE_SUCCEEDED: {
			return {
				...state,
				isDirty: true,
				pendingCreate: false,
			};
		}

		default: {
			return state;
		}
	}
};



// WEBPACK FOOTER //
// ./src/redux/notes/notes.reducer.js